var map = {
	"./template-1/lobby/lobby": "app/styles/client/templates/template-1/lobby/lobby",
	"./template-10/lobby/lobby": "app/styles/client/templates/template-10/lobby/lobby",
	"./template-11/lobby/lobby": "app/styles/client/templates/template-11/lobby/lobby",
	"./template-2/lobby/lobby": "app/styles/client/templates/template-2/lobby/lobby",
	"./template-3/lobby/lobby": "app/styles/client/templates/template-3/lobby/lobby",
	"./template-4/lobby/lobby": "app/styles/client/templates/template-4/lobby/lobby",
	"./template-5/lobby/lobby": "app/styles/client/templates/template-5/lobby/lobby",
	"./template-6/lobby/lobby": "app/styles/client/templates/template-6/lobby/lobby",
	"./template-7/lobby/lobby": "app/styles/client/templates/template-7/lobby/lobby",
	"./template-8/lobby/lobby": "app/styles/client/templates/template-8/lobby/lobby",
	"./template-9/lobby/lobby": "app/styles/client/templates/template-9/lobby/lobby"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2161;